import { type Control, type FormContextValues } from 'react-hook-form'
import { type CollectionsFormData } from 'domains/collections/components/collections-form/utils/collectionsForm.types'

export enum CollectionRuleType {
  searchTerm = 'SEARCH_TERM',
  productCodes = 'PRODUCT_CODES',
}

export interface CollectionRuleSearchTerm {
  type: CollectionRuleType.searchTerm
  searchTerm: string
  name: string
  subjectId?: string
}

export interface CollectionRuleProductCodes {
  type: CollectionRuleType.productCodes
  productIds: string[]
  name: string
  subjectId?: string
}

export type CollectionRule = CollectionRuleSearchTerm | CollectionRuleProductCodes

export interface CollectionsRuleProps {
  formPrefix: string
  register: FormContextValues<CollectionsFormData>['register']
  control: Control<CollectionsFormData>
  retailerId: string
}
